/* eslint-disable no-var */

/** @type {number} */
// @ts-ignore - Global constant
var ON_CHANGE_DEBOUNCE_TIMER = 300;

/**
 * @type {PubSubEvents}
 */
// @ts-ignore - Global constant
var PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
